import { useState, useMemo, useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'

import { getViewTabViewRecords } from '../../../../data/dataServices'

export function useViewReducer(props) {
	const { viewKey, tile, enabled: shouldQuery } = props

	const { environment } = useSelector((state) => state)

	const [viewData, setViewData] = useState(null)

	const enabled = useMemo(() => {
		return shouldQuery && Boolean(viewKey)
	}, [shouldQuery, viewKey])

	const {
		data,
		isLoading: viewLoading,
		isFetching: viewFetching,
		refetch: reloadViews,
	} = useQuery({
		queryKey: [tile?.type, tile?.key, viewKey],
		queryFn: () =>
			getViewTabViewRecords({
				viewKey,
				token: environment?.apiToken,
				shouldRemoveViewSession: true,
			}),
		enabled,
	})

	useEffect(() => {
		if (viewFetching) return
		const viewData = data?.data
		setViewData(viewData)
	}, [viewFetching, data])

	return {
		viewData,
		viewLoading: viewFetching,
		reloadViews,
	}
}
